<template>
  <div>
    <joy-page :joyPageStatus="joyPageStatus">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <template v-if="list.length==0">
          <noneData></noneData>
        </template>
        <template v-else>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="加载完毕"
            @load="onLoad"
          >
            <div
              class="cu-card"
              v-for="(item,index) in list"
              :key="index"
            >
              <div class="cu-item shadow">
                <van-cell>
                  <span
                    style="font-weight: 600;"
                    slot="title"
                  >{{item.activity}}</span>
                </van-cell>
                <van-cell
                  title="活动时间"
                  :value="item.activity_date"
                />
                <van-cell
                  title="姓名"
                  :value="item.name"
                />
                <van-cell
                  title="职位"
                  :value="item.job"
                />
                <van-cell
                  title="天数"
                  :value="item.days"
                />
                <van-cell
                  title="薪酬"
                  :value="item.wage"
                />
                <van-cell>
                  <div style="float: right;">
                    <van-button
                      size="mini"
                      :disabled="item.disabledValue"
                      :type="item.confirm_status==='0'?'danger':'primary'"
                      @click="item.confirm_status==='0'?onDialog(item.id):''"
                    >{{item.textValue}}</van-button>
                  </div>

                </van-cell>

              </div>
            </div>
          </van-list>
        </template>
      </van-pull-refresh>
    </joy-page>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
export default {
  created(e) {
    this.onLoad()
  },
  data() {
    return {
      joyPageStatus: '',
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
    }
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.reload()
        this.$toast('刷新成功')
      }, 500)
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.loadData()
      }, 500)
    },
    reload() {
      this.list = []
      this.loading = false
      this.finished = false
      this.onLoad()
    },
    loadData() {
      const that = this
      this.joyPageStatus = 'loading'
      try {
        this.$axios.get('salary/list').then((res) => {
          if (res.data.code == 200) {
            this.joyPageStatus = 'success'
            let data = res.data.data
            for (let i = 0; i < data.length; i++) {
              data[i].confirm_status === '0'
                ? (data[i].textValue = '待确认') &&
                  (data[i].disabledValue = false)
                : (data[i].textValue = '已确认') &&
                  (data[i].disabledValue = true)
            }

            this.list = data
            this.loading = false
            this.finished = true
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    // 点击提示
    onDialog(id) {
      Dialog.confirm({
        message: '确认已收到该笔薪资',
      })
        .then(() => {
          this.$axios
            .post('salary/confirm', {
              id: id,
            })
            .then((res) => {
              if (res.data.code == 400) {
                Toast(res.data.msg)
                return
              }
              this.loadData()
            })
        })
        .catch(() => {
          // on cancel
        })
    },
  },
}
</script>

<style>
</style>
